import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { MultipleCountersStore } from '../../stores/DashboardStore';
import { formatNumber, formatInteger } from '../../format';
import Button from '../Button';
import WidgetBase from './WidgetBase';
import './WidgetMultipleCounters.css';

const block = b.lock('WidgetMultipleCounters');

class WidgetMultipleCounters extends Component {
    static propTypes = {
        store: MultipleCountersStore.PropType.isRequired,
        label: PropTypes.string.isRequired,
    };

    render() {
        const { store, label, ...props } = this.props;
        return <WidgetBase
            flipStore={store.flip}
            flipClassName={block('Flip')}
            {...props}
        >
            <div className={block('Content')}>
                <div
                    className={block('Value', { index: 0 })}
                    title={formatInteger(store.values[0])}
                >
                    {formatNumber(store.values[0])}
                </div>
                <div className={block('Label')}>
                    {label}
                </div>
                <div
                    className={block('Value', { index: 1 })}
                    title={formatInteger(store.values[store.tabId + 1])}
                >
                    {formatNumber(store.values[store.tabId + 1])}
                </div>
                <div className={block('Label')}>
                    {store.tabs[store.tabId].label}
                </div>
            </div>
            <div className={block('TabsWrapper')}>
                <div className={block('Spacer')} />
                {store.tabs.map(({ title }, index) => <Button
                    key={title}
                    className={block('Tab', { active: store.tabId === index })}
                    onClick={() => store.setTabId(index)}
                >{title}</Button>)}
                <div className={block('Spacer')} />
            </div>
        </WidgetBase>;
    }
}

export default observer(WidgetMultipleCounters);
